import { render } from "./flat-fee-trademark-registration-package.vue?vue&type=template&id=13e46ab1&scoped=true"
import script from "./flat-fee-trademark-registration-package.vue?vue&type=script&lang=js"
export * from "./flat-fee-trademark-registration-package.vue?vue&type=script&lang=js"

import "./flat-fee-trademark-registration-package.vue?vue&type=style&index=0&id=13e46ab1&lang=css"
import "./flat-fee-trademark-registration-package.vue?vue&type=style&index=1&id=13e46ab1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e46ab1"]])

export default __exports__